import React from 'react';
import { useNavigate } from 'react-router-dom';
import FloatingActionButton from '../components/common/FloatingActionButton';
import IrreplacableHero from '../components/irreplaceable/IrreplacableHero';
import IrreplacableQuestionnaireSection from '../components/irreplaceable/IrreplacableQuestionnaireSection';
import IrreplacableFeatures from '../components/irreplaceable/IrreplacableFeatures';
import IrreplacableProblems from '../components/irreplaceable/IrreplacableProblems';
import IrreplacableHowItWorks from '../components/irreplaceable/IrreplacableHowItWorks';
import IrreplacableExampleReportSection from '../components/irreplaceable/IrreplacableExampleReportSection';
import IrreplacablePricing from '../components/irreplaceable/IrreplacablePricing';
import IrreplacableFooter from '../components/irreplaceable/IrreplacableFooter';
import IrreplacableNavbar from '../components/irreplaceable/IrreplacableNavbar';
import EarlyAccessBand from '../components/EarlyAccessBand';
import { getAutomationById } from '@/services/automation';
import { useEffect, useState } from 'react';

export default function Irreplaceable() {
  const navigate = useNavigate();
  const [typeformUrl, setTypeformUrl] = useState<string | null>(null);

  useEffect(() => {
    const fetchTypeformUrl = async () => {
      try {
        const automation = await getAutomationById('irreplaceable');
        if (automation?.url) {
          setTypeformUrl(automation.url);
        } else {
          console.error('Typeform URL not found in automation');
        }
      } catch (error) {
        console.error('Error fetching typeform URL:', error);
      }
    };

    fetchTypeformUrl();
  }, []);

  const handleGetStarted = () => {
    const objectiveSection = document.getElementById('objective-selector');
    if (objectiveSection) {
      objectiveSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
      objectiveSection.focus();
    }
  };

  return (
    <div className="min-h-screen bg-dark">
      <IrreplacableNavbar onGetStarted={handleGetStarted} />
      <IrreplacableHero onGetStarted={handleGetStarted} />
      <IrreplacableProblems />
      <IrreplacableQuestionnaireSection />
      <IrreplacableFeatures />
      <IrreplacableHowItWorks />
      <IrreplacableExampleReportSection />
      <IrreplacablePricing typeformUrl={typeformUrl} />
      <IrreplacableFooter />
{/*      <EarlyAccessBand /> */}
      <FloatingActionButton />
    </div>
  );
}